import React from "react";
import PageTitle from "../../../components/PageTitle";
import { Row, Col, Button, Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { user, isUserLoading } from "../../../selectors/users";
import UsernameForm from "../../../components/forms/Username";
import ChangePasswordForm from "../../../components/forms/ChangePassword";
import {
  userPageLoad,
  userUsernameChangeRequest,
  userPasswordChangeRequest,
  userEnableRequest,
  userDisableRequest,
} from "../../../actions/users";
import { push } from "react-router-redux";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default props => <EditUserPage username={props.match.params.id} />;

const EditUserPage = connect(
  (state, ownProps) => ({
    user: user(state),
    loading: isUserLoading(state),
    username: isUserLoading(state) ? null : user(state).username,
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(userPageLoad(ownProps.username)),
    onChangeUsername: (username, newUsername) =>
      dispatch(userUsernameChangeRequest(username, newUsername)),
    onChangePassword: (username, password) =>
      dispatch(userPasswordChangeRequest(username, password)),
    onEnable: username => dispatch(userEnableRequest(username)),
    onDisable: username => dispatch(userDisableRequest(username)),
    onUserList: () => dispatch(push("/users")),
  }),
  (stateProps, dispatchProps, ownProps) =>
    Object.assign({}, stateProps, dispatchProps, ownProps, {
      onChangeUsername: username =>
        dispatchProps.onChangeUsername(stateProps.username, username),
      onChangePassword: password =>
        dispatchProps.onChangePassword(stateProps.username, password),
      onEnable: () => dispatchProps.onEnable(stateProps.username),
      onDisable: () => dispatchProps.onDisable(stateProps.username),
    }),
)(
  componentWithLoadTrigger(props => {
    if (props.loading) {
      return <PageTitle title="Loading..." />;
    }

    return (
      <div id="edit-user-page">
        <PageTitle title={`Edit ${props.user.admin ? "ADMIN" : "TECH"} User`} />
        <div>
          <a id="back" style={{ cursor: "pointer" }} onClick={props.onUserList}>
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to users list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Change Username</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <p>
                  {" "}
                  Do not forget to announce the owner(s) of the account that the
                  username has changed.{" "}
                </p>
                <UsernameForm
                  user={props.user}
                  onSave={formData => props.onChangeUsername(formData.username)}
                  disabled={props.user.changeUsernameInProgress}
                  backendError={props.user.changeUsernameError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Change Password</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <p>
                  {" "}
                  Do not forget to announce the owner(s) of the account that the
                  password has changed.{" "}
                </p>
                <ChangePasswordForm
                  onSave={formData => props.onChangePassword(formData.password)}
                  disabled={props.user.changePasswordInProgress}
                  backendError={props.user.changePasswordError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">
              {props.user.enabled ? "Disable " : "Enable "}
              User
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <p>
                  {" "}
                  This action will immediately change the status of the user.{" "}
                </p>
                <Button
                  id="toggle-enable-user"
                  onClick={() =>
                    props.user.enabled ? props.onDisable() : props.onEnable()
                  }
                  disabled={
                    props.user.enableInProgress || props.user.disableInProgress
                  }
                  bsStyle={props.user.enabled ? "danger" : "success"}
                >
                  {props.user.enabled ? "Disable" : "Enable"}
                </Button>
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/users/Edit.js